import React, { useState, useEffect } from "react"

import ReactModal from "react-modal"
import { Link, graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"
import styles from "./introduction.module.css"

import deviceImage from "../../images/introducing-flex-devices-desktop-v2.png"
import ovalImgMobileLarge from "../../images/oval-large-mobile-v2.svg"
import ovalImgMobileSmall from "../../images/oval-small-mobile-v2.svg"
import ovalImgDesktopLarge from "../../images/oval-large-desktop-v2.svg"
import ovalImgDesktopSmall from "../../images/oval-small-desktop-v2.svg"

const Introduction = ({ className }) => {
  // const { mobileImage, desktopImage } = useStaticQuery(graphql`
  //   query {
  //     mobileImage: file(
  //       relativePath: { eq: "introducing-flex-devices-mobile-v2.png" }
  //     ) {
  //       childImageSharp {
  //         fluid(maxWidth: 490, quality: 100) {
  //           ...GatsbyImageSharpFluid_withWebp
  //         }
  //       }
  //     }
  //     desktopImage: file(
  //       relativePath: { eq: "introducing-flex-devices-desktop-v2.png" }
  //     ) {
  //       childImageSharp {
  //         fluid(maxWidth: 768, quality: 100) {
  //           ...GatsbyImageSharpFluid_withWebp
  //         }
  //       }
  //     }
  //   }
  // `)

  // this.handleOpenModal = this.handleOpenModal.bind(this);
  //   this.handleCloseModal = this.handleCloseModal.bind(this);
  // }
  

  // const sources = [
  //   mobileImage.childImageSharp.fluid,
  //   {
  //     ...desktopImage.childImageSharp.fluid,
  //     media: `(min-width: 491px)`,
  //   },
  // ]


  // const handleCloseModal =  () => {
  //   this.setState({ showModal: false });
  // }

  // const imageUrl = window.innerWidth >= 650 ? desktopImage : mobileImage

  return (
    <div className={styles.Wrapper}>
      <div className={styles.positionWrapper}>
        <div className={styles.deviceImageWrapper}>
          <img
            src={deviceImage}
            className={styles.Devices}
            alt="Device Image"
          />
        </div>

        <div className={styles.ovalsMobile}>
          <img
            src={ovalImgMobileLarge}
            alt="Large oval image for mobile layout"
          />
          <div className={styles.smallOval}>
            <img
              src={ovalImgMobileSmall}
              alt="Small oval image for mobile layout"
            />
          </div>
        </div>

        <div className={styles.ovalsDesktop}>
          <img
            src={ovalImgDesktopLarge}
            alt="Large oval image for desktop layout"
          />
          <div className={styles.smallOval}>
            <img
              src={ovalImgDesktopSmall}
              alt="Small oval image for desktop layout"
            />
          </div>
        </div>
      </div>

      <div className={styles.CopyWrapper}>
        <div className={styles.Copy}>
          <h2>Introducing Flex</h2>
          <p>
            At-home workouts are the new normal, but that doesn’t mean there is
            a one-size-fits all solution to making your workout fit your
            lifestyle. We recognize the potential of individuals to know what
            types of workout routines work best for them, and when it comes to
            health, Flex wants to give users more creativity to achieve their
            personal goals.
          </p>
          {/* <button className={styles.Button}>Sign Up</button> */}
          {/* <GatsbyLink to="/signup" className={styles.Button}>
            Sign up
          </GatsbyLink> */}
          {/* <button className={styles.Button} onClick={handleOpenModal}>
            Tell me more
          </button> */}
          <Link
            to="/#about"
            className={styles.Button}
            // onClick={handleOpenModal}
          >
            Tell me more
          </Link>

          {/* Docs:https://reactcommunity.org/react-modal/ */}
          {/* <ReactModal
            isOpen={showModal}
            contentLabel="Sign Up Modal"
            portalClassName="modal"
            shouldCloseOnOverlayClick={true}
            onRequestClose={handleOpenModal}
          >
            <button onClick={handleOpenModal}>X</button>
          </ReactModal> */}

        </div>

        <div></div>
      </div>
    </div>
  )
}

export default Introduction
